import 'regenerator-runtime/runtime';
import { AtalayaWrapper } from '@therms/atalaya';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppRouter } from './AppRouter';
import '@therms/atalaya/css/base.css';

const App = () => {
  return <AppRouter />;
};

ReactDOM.render(
  <AtalayaWrapper>
    <App />
  </AtalayaWrapper>,
  document.querySelector('#root'),
);

// dev env HMR
// @ts-ignore
if (module?.hot) {
    // @ts-ignore
  module.hot.accept();
}
